import React from 'react';
import { Box, Typography, TextField } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RefreshIcon from '@material-ui/icons/Refresh';
import SaveIcon from '@material-ui/icons/Save';
import { RMSButton } from '../../buttons';

const RMSDataGridToolbar = ({
  toolbar,
  rowOrder,
  rowCount,
  searchText,
  onSearchChange,
  onSortAZ,
  hasOrderChanged = false,
  onSaveOrder,
}) => {
  const {
    title = '',
    caption = '',
    searchable = true,
    actions = {},
    toolbarActions = null,
  } = toolbar;

  const { showAddButton = false, onAdd, showRefreshButton = false, onRefresh } = actions;
  const { enableRowReorder = false, showAtoZButton } = rowOrder;

  return (
    <Box
      p={2}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      gridGap={8}
      borderBottom="1px solid #e0e0e0">
      {/* Left Side */}
      <Box>
        {title && <Typography variant="h6">{title}</Typography>}

        {caption && (
          <Typography variant="caption" color="textSecondary">
            {caption}
          </Typography>
        )}
      </Box>

      {/* Right Side */}
      <Box display="flex" alignItems="center" gridGap={8} flexWrap="wrap">
        {searchable && (
          <TextField
            size="small"
            variant="outlined"
            placeholder="Search..."
            value={searchText}
            onChange={(e) => onSearchChange?.(e.target.value)}
          />
        )}

        {showAtoZButton && <RMSButton label="A-Z" variant="outlined" onClick={onSortAZ} />}

        {enableRowReorder && hasOrderChanged && (
          <RMSButton
            label="Save Order"
            color="primary"
            prefixIcon={<SaveIcon />}
            onClick={onSaveOrder}
          />
        )}
        {showRefreshButton && (
          <RMSButton
            label="Refresh"
            variant="outlined"
            color="default"
            prefixIcon={<RefreshIcon />}
            onClick={onRefresh}
          />
        )}

        {showAddButton && <RMSButton label="Add" prefixIcon={<AddIcon />} onClick={onAdd} />}

        {/* Custom Buttons */}
        {toolbarActions}

        <Typography variant="caption" color="textSecondary">
          {rowCount} rows
        </Typography>
      </Box>
    </Box>
  );
};

export default RMSDataGridToolbar;
